<template>
    <div class="report-calendar" v-if="!isFinal">
        <Canlendar buttonText="From" keyItem="from" :maxDate="dateTo" />
        <Canlendar buttonText="To" keyItem="to" :minDate="dateFrom" />
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import Canlendar from '@/components/common/calendar/calendar.vue';

export default {
    mixins: [languageMixins],
    components: { Canlendar },
    props: {
        isFinal: {
            type: Boolean,
            default: true,
        },
        dateTo: {
            type: String,
            default: '',
        },
        dateFrom: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
